import { useEffect } from 'react';
import { Stack } from 'ui';

import { PartFour } from './PartFour';
import { PartOne } from './PartOne';
import { PartThree } from './PartThree';
import { PartTwo } from './PartTwo';

export const AiLooseGuide = ({ currentStep, obfuscateAi }: { currentStep: number; obfuscateAi: boolean }) => {
  useEffect(() => {
    const element = document.getElementById('ai-loose-guide');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }, [currentStep]);

  return (
    <Stack
      id="ai-loose-guide"
      sx={{
        gap: 2,
      }}
    >
      {currentStep === 1 ? <PartOne obfuscateAi={obfuscateAi} /> : null}
      {currentStep === 2 ? <PartTwo /> : null}
      {currentStep === 3 ? <PartThree obfuscateAi={obfuscateAi} /> : null}
      {currentStep === 4 ? <PartFour /> : null}
    </Stack>
  );
};
